[
  {
    "code": "LU-D",
    "name": "Diekirch"
  },
  {
    "code": "LU-G",
    "name": "Grevenmacher "
  },
  {
    "code": "LU-L",
    "name": "Luxemburg"
  }
]